module.exports = __webpack_public_path__ + "img/bg.c67160cc.jpg";